import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function getSetPriority(salesOrg: string, salesOffice?: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/planning/priority`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function savePriority(
  salesOrg: string,
  category: string,
  machineType: string,
  volume: number,
  volumePeriod: number,
  driSetting: number,
  visitDaysWithin: string,
  aspd: number,
  volEdit: boolean
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      category,
      machineType,
      volume,
      volumePeriod,
      driSetting,
      visitDaysWithin,
      aspd,
      volEdit,
    },
    url: `${BASE_URL}/api/planning/priority/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function editPriority(
  salesOrg: string,
  category: string,
  machineType: string,
  volume: number,
  volumePeriod: number,
  driSetting: number,
  visitDaysWithin: string,
  aspd: number,
  volEdit: boolean
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      category,
      machineType,
      volume,
      volumePeriod,
      driSetting,
      visitDaysWithin,
      aspd,
      volEdit,
    },
    url: `${BASE_URL}/api/planning/priority/edit`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function setVolumePeriod(salesOrg: string, volumePeriod: number) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      volumePeriod,
    },
    url: `${BASE_URL}/api/planning/priority/setVolPeriod`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}